'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAccountSummary = exports.userAnnouncements = exports.userSignUpFacebook = exports.userSignUpEmail = exports.userCreditBalanceBreakdown = exports.userCreditBalance = exports.studioBookmarks = exports.userVideoReservations = exports.userUpcomingReservations = exports.userPastReservations = exports.userPastReservationsCount = exports.userInactivePermissions = exports.userPermissions = exports.userProfile = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _sagaTools = require('@classpass/saga-tools');

var _scheduleContext = require('constants/schedule-context');

var _scheduleContext2 = _interopRequireDefault(_scheduleContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProfile = exports.userProfile = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_PROFILE', function (client) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$forceReadFromMas = _ref.forceReadFromMaster,
      forceReadFromMaster = _ref$forceReadFromMas === undefined ? false : _ref$forceReadFromMas;

  if (client.isUsingUnauthenticatedToken()) {
    if (__LOCAL_DEV__) {
      throw new Error('Refusing to make request for user profile endpoint with admin token.');
    } else {
      console.error('Returning null for request of user profile endpoint with admin token.'); // eslint-disable-line no-console
      return _promise2.default.resolve(null);
    }
  }

  return client.users.activeUserProfile({ fields: 'profile_image_url' }, {
    headers: forceReadFromMaster ? { 'with-master': 1 } : {}
  });
});

var userPermissions = exports.userPermissions = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_PERMISSIONS', function (client, userId) {
  return client.users.viewPermissions(userId);
});

var userInactivePermissions = exports.userInactivePermissions = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_INACTIVE_PERMISSIONS', function (client, userId) {
  return client.users.inactivePermissions(userId);
});

// Past classes over entire lifetime are not included in the userProfile
var userPastReservationsCount = exports.userPastReservationsCount = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_PAST_RESERVATIONS_COUNT', function (client, userId) {
  return client.users.viewFutureReservations(userId, { past: true, meta_only: true }).then(function (data) {
    return data.meta;
  });
});

var userPastReservations = exports.userPastReservations = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_PAST_RESERVATIONS_RESERVATIONS', function (client, userId) {
  return client.users.viewReservationsV2(userId, { past: true }).then(function (data) {
    return data.reservations;
  });
});

var userUpcomingReservations = exports.userUpcomingReservations = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_UPCOMING_RESERVATIONS', function (client, userId) {
  return client.users.viewReservationsV2(userId).then(function (data) {
    return data.reservations;
  });
});

var userVideoReservations = exports.userVideoReservations = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_VIDEO_RESERVATIONS', function (client, userId) {
  return client.users.viewVideoReservations(userId);
});

var studioBookmarks = exports.studioBookmarks = (0, _sagaTools.makeEntityScaffold)('SAGA.API.STUDIO_BOOKMARKS', function (client, userId) {
  return client.users.getBookmarks(userId).then(function (data) {
    return data.bookmarks;
  });
});

var userCreditBalance = exports.userCreditBalance = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_CREDIT_BALANCE', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isNextCycle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return client.lifecycle.getCreditBalance(userId, options, isNextCycle).then(function (data) {
    return data.data.credit_balance;
  });
}, { defaultKey: function defaultKey(client, userId, options, isNextCycle) {
    return isNextCycle ? _scheduleContext2.default.NEXT_CYCLE : _scheduleContext2.default.CURRENT_CYCLE;
  } });

var userCreditBalanceBreakdown = exports.userCreditBalanceBreakdown = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_CREDIT_BALANCE_BREAKDOWN', function (client, userId) {
  return client.lifecycle.getCreditBalanceBreakdown(userId).then(function (data) {
    return data.data.sources.reduce(function (sources, source) {
      sources[source.credit_source] = (0, _extends3.default)({}, source);
      return sources;
    }, {});
  });
});

var userSignUpEmail = exports.userSignUpEmail = (0, _sagaTools.makeEntityScaffold)('SAGA.API.EMAIL_SIGNUP', function (client, userData, signUpData) {
  var firstName = userData.firstName,
      lastName = userData.lastName,
      email = userData.email,
      password = userData.password,
      newsletterSubscribed = userData.newsletterSubscribed;
  var conversion = signUpData.conversion,
      planId = signUpData.planId,
      promotionId = signUpData.promotionId,
      offerId = signUpData.offerId,
      scheduleId = signUpData.scheduleId;


  return client.users.create((0, _extends3.default)({
    user: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password
    },
    newsletter_subscribed: newsletterSubscribed
  }, conversion && (0, _keys2.default)(conversion).length && { conversion: conversion }, planId && { plan_id: planId }, promotionId && { promotion_id: promotionId }, offerId && { offer_id: offerId }, scheduleId && { alc_schedule_id: scheduleId }));
});

var userSignUpFacebook = exports.userSignUpFacebook = (0, _sagaTools.makeEntityScaffold)('SAGA.API.FACEBOOK_SIGNUP', function (client, token, signUpData) {
  var conversion = signUpData.conversion,
      planId = signUpData.planId,
      promotionId = signUpData.promotionId,
      offerId = signUpData.offerId,
      scheduleId = signUpData.scheduleId;


  return client.users.create((0, _extends3.default)({
    facebook: { token: token }
  }, conversion && (0, _keys2.default)(conversion).length && { conversion: conversion }, planId && { plan_id: planId }, promotionId && { promotion_id: promotionId }, offerId && { offer_id: offerId }, scheduleId && { alc_schedule_id: scheduleId }));
});

var userAnnouncements = exports.userAnnouncements = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_ANNOUNCEMENTS', function (client) {
  return client.users.announcements();
});

var userAccountSummary = exports.userAccountSummary = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_ACCOUNT_SUMMARY', function (client) {
  return client.users.accountSummary();
});